<template>
  <div class="no-select home pointer" v-touch:swipe.left="nextPhoto" v-touch:swipe.right="prevPhoto" @click="nextPhoto">
      <v-wait for="image-load">
        <template slot="waiting">
          <div class="vh-100 dt w-100 aspect-ratio--object bg-white-90">
            <div class="dtc v-mid tc white ph3 ph4-l">
              <h1 class="f6 f2-m f-subheadline-l fw6 tc black">Loading</h1>
            </div>
          </div>
        </template>
        <!-- <div id="photo_landscape" class="vh-100 dt w-100 cover bg-center" :style="{'background-image': 'url(' + currentPhoto.photo + ')'}"></div>
        <div id="photo_vertical" class="vh-100 dt w-100 cover bg-center" :style="{'background-image': 'url(' + currentPhoto.photo_vertical + ')'}"></div> -->
        <img id="photo_landscape" draggable="false" class="no-select vh-100 dt w-100 fit" :src="currentPhoto.photo">
        <img id="photo_vertical" draggable="false" class="no-select vh-100 dt w-100 fit" :src="currentPhoto.photo_vertical">
      </v-wait>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      currentPhoto: {},
      allPhotos: []
    }
  },
  methods: {
    randomPhoto() {
      var randomIndex = Math.floor(Math.random() * this.allPhotos.length);

      this.currentPhoto = {
        photo: this.allPhotos[randomIndex].data.photo.url.substring( 0, this.allPhotos[randomIndex].data.photo.url.indexOf( '?auto=compress,format' ) ),
        photo_vertical: this.allPhotos[randomIndex].data.photo_vertical.url.substring( 0, this.allPhotos[randomIndex].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
        index: randomIndex
      };
    },
    firstPhoto() {
      // var randomIndex = Math.floor(Math.random() * this.allPhotos.length);

      this.currentPhoto = {
        photo: this.allPhotos[0].data.photo.url.substring( 0, this.allPhotos[0].data.photo.url.indexOf( '?auto=compress,format' ) ),
        photo_vertical: this.allPhotos[0].data.photo_vertical.url.substring( 0, this.allPhotos[0].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
        index: 0
      };
    },
    nextPhoto() {
      if (this.currentPhoto.index == (this.allPhotos.length - 1)) {
        this.currentPhoto = {
          photo: this.allPhotos[0].data.photo.url.substring( 0, this.allPhotos[0].data.photo.url.indexOf( '?auto=compress,format' ) ),
          photo_vertical: this.allPhotos[0].data.photo_vertical.url.substring( 0, this.allPhotos[0].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
          index: 0
        };
      }
      else {
        var nextIndex = parseInt(this.currentPhoto.index) + 1;

        this.currentPhoto = {
          photo: this.allPhotos[nextIndex].data.photo.url.substring( 0, this.allPhotos[nextIndex].data.photo.url.indexOf( '?auto=compress,format' ) ),
          photo_vertical: this.allPhotos[nextIndex].data.photo_vertical.url.substring( 0, this.allPhotos[nextIndex].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
          index: nextIndex
        };
      }
    },
    prevPhoto() {
      if (this.currentPhoto.index == 0) {
        this.currentPhoto = {
          photo: this.allPhotos[this.allPhotos.length - 1].data.photo.url.substring( 0, this.allPhotos[this.allPhotos.length - 1].data.photo.url.indexOf( '?auto=compress,format' ) ),
          photo_vertical: this.allPhotos[this.allPhotos.length - 1].data.photo_vertical.url.substring( 0, this.allPhotos[this.allPhotos.length - 1].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
          index: (this.allPhotos.length - 1)
        };
      }
      else {
        var prevIndex = parseInt(this.currentPhoto.index) - 1;

        this.currentPhoto = {
          photo: this.allPhotos[prevIndex].data.photo.url.substring( 0, this.allPhotos[prevIndex].data.photo.url.indexOf( '?auto=compress,format' ) ),
          photo_vertical: this.allPhotos[prevIndex].data.photo_vertical.url.substring( 0, this.allPhotos[prevIndex].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
          index: prevIndex
        };
      }
    }
  },
  created() {
    var that = this;

    this.$wait.start('image-load');

    this.$store.dispatch('fetchPhotos', { vm: this, cb:
      function(results) {
        // that.allPhotos = results;
        that.allPhotos = results.sort((a, b) => parseInt(b.data.order) - parseInt(a.data.order));
        if (that.$route.params.photo_id == undefined ||
            that.$route.params.photo_id >= that.allPhotos.length ||
            isNaN(that.$route.params.photo_id)) {
          // that.randomPhoto();
          that.firstPhoto();
        }
        else {
          that.currentPhoto = {
            photo: that.allPhotos[that.$route.params.photo_id].data.photo.url.substring( 0, that.allPhotos[that.$route.params.photo_id].data.photo.url.indexOf( '?auto=compress,format' ) ),
            photo_vertical : that.allPhotos[that.$route.params.photo_id].data.photo_vertical.url.substring( 0, that.allPhotos[that.$route.params.photo_id].data.photo_vertical.url.indexOf( '?auto=compress,format' ) ),
            index : that.$route.params.photo_id
          };
        }

        that.$wait.end('image-load');

        window.addEventListener('keydown', function(e) {
          // console.log(e.keyCode);
          if (e.keyCode == 39 || e.keyCode == 32) { //right arrow or spacebar
            that.nextPhoto();
          }
          else if (e.keyCode == 37) {
            that.prevPhoto();
          }
        });
        
        document.body.classList.add("overflow-hidden");
      }
    });
  },
  destroyed() {
    document.body.classList.remove("overflow-hidden");
    window.removeEventListener('keydown', function(e) {
      console.log(e.keyCode);
      if (e.keyCode == 39 || e.keyCode == 32) { //right arrow or spacebar
        that.nextPhoto();
      }
      else if (e.keyCode == 37) {
        that.prevPhoto();
      }
    });
  }
}
</script>

<style scoped>
  img {
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .fit {
    /*-o-object-fit: contain;
    object-fit: contain;*/
    -o-object-fit: cover;
    object-fit: cover;
  }

  #photo_landscape { display: block; }
  #photo_vertical { display: none; }

  .no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  @media screen and (max-width: 768px) {
    #photo_landscape { display: none; }
    #photo_vertical { display: block; }
  }
</style>
